import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type {
  PatchBoardQueueGroupRequest,
  PatchBoardQueueGroupResponse,
} from '../types';

export const patchBoardQueueGroup = async ({
  pathParams: { organisationId, boardId, queueGroupId },
  body,
}: PatchBoardQueueGroupRequest) => {
  const url = `/api/v2/organisations/${organisationId}/boards/${boardId}/queue/groups/${queueGroupId}`;
  const { data } = await apiAuthClient.patch<PatchBoardQueueGroupResponse>(
    url,
    body,
  );
  return data.data;
};
